// extracted by mini-css-extract-plugin
module.exports = {"page":"StartPage_page__3YdEc","welcomeSegment":"StartPage_welcomeSegment__24-B5"};